import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { noetivraDemoUrl } from '../../data/noetivra';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  const scrollToWork = () => {
    document.getElementById('what-we-build')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-389" data-mp="2wvg4ou9u35o5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-390" data-mp="31s6itc22vr6x">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-391" data-mp="2n3sfl00r20pu">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-392" data-mp="3fqwgasst7svt">
            Connected knowledge. Stronger judgment. Greater human capability.
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-393" data-mp="jw4jiic04e2l">
            SyNeural connects governed knowledge, structured capability
            development and practical action. Our architecture brings together
            the Semantic Knowledge Platform, Human Capability Framework and
            Noetivra workspace to help institutions understand needs,
            coordinate support and evaluate results.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-394" data-mp="12m3z8elycgtc">
            <button type="button" onClick={scrollToWork} className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-395" data-mp="1gmompo2tb0t6">
              Explore the Platform
              <ArrowRight size={18} aria-hidden="true" data-id="element-396" data-mp="3edzixk0mnf0g" />
            </button>
            <a href={noetivraDemoUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border border-navy text-navy hover:bg-surface-muted font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-397" data-mp="1hcu0w800zb50">
              Open Noetivra Demo
              <ArrowUpRight size={18} aria-hidden="true" data-id="element-398" data-mp="20b6d62m8h14t" />
              <span className="sr-only" data-id="element-399" data-mp="208k4u0riqhlj">(opens in a new tab)</span>
            </a>
          </div>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-400" data-mp="2a0hhzd237jmw">
          <IntelligenceDiagram data-id="element-401" data-mp="2a1iullyr4e6q" />
        </div>
      </div>
    </section>;
}